import { TIframeSettings } from '@treedis/tour-loader';

export enum MenuType {
  Treedis = 'treedis',
  NavigationPath = 'navigationPath',
  Matterport = 'matterport',
  MatterportInstant = 'matterport-instant',
  MatterportLabel = 'matterport-label',
  MatterportFloor = 'matterport-floor',
  Popup = 'popup',
  Tab = 'tab',
  Tag = 'tag',
  Panorama = 'panorama',
  Product = 'product',
  Iframe = 'iframe',
  Category = 'category',
}

export interface Menu {
  id?: number;
  title: string;
  url?: string;
  type: MenuType;
  subMenus?: Menu[];
  subSubMenus?: Menu[];
  panoramaId?: number;
  tag?: string;
  labelId?: string;
  floorId?: number;
  changeMinimap?: boolean;
  changePanorama?: boolean;
  changeReel?: boolean;
  iframeSettings?: TIframeSettings;
  shouldHighlight?: boolean;
}
